import { useAppDispatch } from '@casops/store/hooks';
import { casOpsApi, QueryTag } from '@casops/store/api';
import { useCallback } from 'react';
import CasRefreshButton, {
  RefreshButtonControllerProps,
} from '@cas/components/inputs/refresh-button/RefreshButton';

export const RefreshButton = ({
  tagsToClear,
  disabled,
}: RefreshButtonControllerProps<QueryTag>) => {
  const dispatch = useAppDispatch();

  const invalidateTagsCallback = useCallback(() => {
    dispatch(casOpsApi.util.invalidateTags(tagsToClear));
  }, [dispatch, tagsToClear]);

  return <CasRefreshButton invalidateTagsCallback={invalidateTagsCallback} disabled={disabled} />;
};

export default RefreshButton;
